module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/appeal_top_sub_03-1f4431228d4007e4eb0359bba96a6da8.jpg";